// Components
import { Button, Header, Body } from "../../UI";
import { Paragraph } from "../../typography";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// Icons
import { Trash, EditIcon } from "../../../SVGS";

const RoleItem = ({ name, permissions, description, deleteAction, editAction }) => {
  return (
    <>
      <Header>
        <div className="roleCardHeader">
          <h3 className="roleName">{name}</h3>
          <div className="actions">
            <Button
              onClick={editAction}
              buttonDesignType={buttonDesignType.ACCENT}
            >
              <EditIcon />
            </Button>
            <Button
              onClick={deleteAction}
              buttonDesignType={buttonDesignType.DANGER}
            >
              <Trash />
            </Button>
          </div>
        </div>
      </Header>
      <Body>
        <div className="permissionsContainer">
          {permissions.map((permission, i) => (
            <span key={i} className="permissionTag">
              {permission.name}
            </span>
          ))}
        </div>
        {description && (
          <Paragraph className="roleDescription">{description}</Paragraph>
        )}
      </Body>
    </>
  );
};

export default RoleItem;
